const zipCodeRegex = new RegExp('^[0-9]{4}( )?[a-zA-Z]{2}$');

export const validZipCode = zipCode => {
    return zipCodeRegex.test(zipCode);
};

export const validHouseNumber = houseNumber => {
    return houseNumber?.length >= 1 && houseNumber?.length <= 5 && isNumeric(houseNumber);
};

export const isNumeric = str => {
    if (typeof str != 'string') {
        return false;
    }

    return !isNaN(str) && !isNaN(parseFloat(str));
};
